// apps/web/src/admin/AdminLoginsView.tsx
import { useEffect, useState } from 'react';
import { apiAdmin } from './apiAdmin.js';

export function AdminLoginsView() {
  const [data, setData] = useState<any | null>(null);
  const [email, setEmail] = useState(''); const [ip, setIp] = useState('');
  async function reload() { setData(await apiAdmin.logins({ email: email || undefined, ip: ip || undefined })); }
  useEffect(() => { void reload(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [email, ip]);
  if (!data) return <p>Loading…</p>;
  return (
    <div>
      <div className="flex gap-2 mb-4">
        <input className="input w-56" placeholder="email…" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input className="input w-56" placeholder="ip…" value={ip} onChange={(e) => setIp(e.target.value)} />
      </div>
      <table className="w-full text-xs">
        <thead className="text-left text-ink-500"><tr><th>When</th><th>Email</th><th>User</th><th>Room</th><th>IP</th><th>User-Agent</th></tr></thead>
        <tbody>
          {data.events.map((e: any) => (
            <tr key={e.id}><td>{new Date(e.createdAt).toLocaleString()}</td><td>{e.email}</td><td>{e.displayName ?? 'Unknown user'}</td><td>{e.room}</td><td>{e.ip}</td><td className="truncate max-w-[180px]">{e.userAgent}</td></tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
